'use strict';

var includes = require('./Array.prototype.includes');

module.exports = {
	includes: includes,
	shim: function shimArrayPrototype() {
		includes.shim();
	}
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/es7-shim/Array.prototype.js
// module id = 779
// module chunks = 0